module.exports = __webpack_public_path__ + "static/media/image-rules.5d74d25d.svg";